import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./recursos-humanos.component.html')
})
export class RecursosHumanosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/recursos-humanos.component.ts
 **/